import { useQuery } from '@tanstack/react-query'
import { getRankingCourses } from '../../../infrastructure/api-ranking'

export const useRankingCourses = () => {
    const queryKey = ['Ranking', 'Courses']

    const { data: rankingCourses, ...rest } = useQuery({
        queryKey,
        queryFn: () => getRankingCourses(),
        retry: 2,
    })

    return {
        rankingCourses,
        ...rest,
    }
}
